import { __awaiter } from "tslib";
import { useQueries, } from "@tanstack/react-query";
function mapArrays(a, b) {
    return a.flatMap((aValue) => b.map((bValue) => [aValue, bValue]));
}
/**
 * Unify both data manager and configuration api
 * @param options
 * @returns
 */
function fetchResources(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { localeCode, contextIdentifier, datamanagerBasePath, configuratorBasePath, } = options;
        if (datamanagerBasePath != null) {
            const { Configuration, UiDictionaryApi } = yield import("@plansoft-configuration-renderer/datamanager-api");
            const api = new UiDictionaryApi(new Configuration({ basePath: datamanagerBasePath }));
            // try to load data from data manager
            return yield api.getUiDictionary({
                localeCode,
                contextIdentifier,
            });
        }
        else {
            // try to load data from configuration api
            const { Configuration, ConfigurationApi } = yield import("@plansoft-configuration-renderer/configuration-api");
            const api = new ConfigurationApi(new Configuration({ basePath: configuratorBasePath }));
            return yield api.getUiTranslations({
                localeId: localeCode,
                contextId: contextIdentifier,
            });
        }
    });
}
/**
 * Fetches translations from the data manager
 * @param options
 * @returns
 */
export function useFetchUiTranslations(options) {
    const { datamanagerBasePath, configuratorBasePath, localeCodes, contexts } = options;
    return useQueries({
        queries: mapArrays(localeCodes, contexts).map(([localeCode, contextIdentifier]) => ({
            queryKey: [
                "UiDictionaryApi.getUiDictionary",
                datamanagerBasePath,
                configuratorBasePath,
                localeCode,
                contextIdentifier,
            ],
            queryFn: () => __awaiter(this, void 0, void 0, function* () {
                const resources = yield fetchResources({
                    localeCode,
                    contextIdentifier,
                    datamanagerBasePath,
                    configuratorBasePath,
                });
                return {
                    localeCode,
                    contextIdentifier,
                    resources,
                };
            }),
            refetchOnWindowFocus: false, // disable default refetch, this is very annoying in development
            refetchOnMount: false, // we mount the hook in several place. this prevents refetch on mount
            staleTime: 60 * 1000, // 1 minute
            retry: false, // do not retry
            // ⚠️do not specify initialData
        })),
        combine: combineResults,
    });
}
function combineResults(results) {
    // combine the results into a single object
    return {
        data: results.reduce((memo, result) => {
            var _a;
            if (result.data == null) {
                return memo;
            }
            const { contextIdentifier, localeCode, resources } = result.data;
            const localeResource = (_a = memo[localeCode]) !== null && _a !== void 0 ? _a : {};
            memo[localeCode] = Object.assign(Object.assign({}, localeResource), { [contextIdentifier]: resources });
            return memo;
        }, {}),
        isError: results.some((result) => result.isError),
        isFetching: results.some((result) => result.isFetching),
        isPending: results.some((result) => result.isPending),
    };
}
//# sourceMappingURL=useFetchUiTranslations.js.map